export const MODULE_NAME = 'gemMeter';
